module.exports = __webpack_public_path__ + "static/media/USDC_BUSD_Cake.821e3e99.png";